export default {
  methods: {
    cloneDataOpening(src, dest, includePenetrantsAndPhotos = false) {
      dest.openingId = _.cloneDeep(src.openingId)
      dest.assemblyTime = _.cloneDeep(src.assemblyTime)
      dest.captureTime = _.cloneDeep(src.captureTime)
      dest.comment = _.cloneDeep(src.comment)
      dest.dbDate = _.cloneDeep(src.dbDate)
      dest.dbUser = _.cloneDeep(src.dbUser)
      dest.fireRating = _.cloneDeep(src.fireRating)
      dest.idOnDrawing = _.cloneDeep(src.idOnDrawing)
      dest.room = _.cloneDeep(src.room)
      dest.tagId = _.cloneDeep(src.tagId)
      dest.wallFloorAssembly = _.cloneDeep(src.wallFloorAssembly)
      dest.zoneId = _.cloneDeep(src.zoneId)
      // if include penetrant and photos
      dest.penetrants = []
      dest.photos = []
      if (includePenetrantsAndPhotos) {
        src.penetrants.forEach(p => this.cloneDataPenetrant(p, dest))
        src.photos.forEach(p => this.cloneDataPhoto(p, dest))
      }
    },
    cloneDataPenetrant(src, dest) {
      //
      const newPenetrant = new Object()
      newPenetrant.penetrantId = _.cloneDeep(src.penetrantId)
      newPenetrant.complexityFactor = _.cloneDeep(src.complexityFactor)
      newPenetrant.count = _.cloneDeep(src.count)
      newPenetrant.isolation = _.cloneDeep(src.isolation)
      newPenetrant.length = _.cloneDeep(src.length)
      newPenetrant.openingId = _.cloneDeep(src.openingId)
      newPenetrant.sizeCategory = _.cloneDeep(src.sizeCategory)
      newPenetrant.system = _.cloneDeep(src.system)
      newPenetrant.type = _.cloneDeep(src.type)
      dest.penetrants.push(newPenetrant)
    },
    cloneDataPhoto(src, dest) {
      const newPhoto = new Object()
      newPhoto.captureTime = _.cloneDeep(src.captureTime)
      newPhoto.captureUser = _.cloneDeep(src.captureUser)
      newPhoto.comment = _.cloneDeep(src.comment)
      newPhoto.openingId = _.cloneDeep(src.openingId)
      newPhoto.photoId = _.cloneDeep(src.photoId)
      newPhoto.registrationType = _.cloneDeep(src.registrationType)
      newPhoto.uri = _.cloneDeep(src.uri)
      dest.photos.push(newPhoto)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/cloneMixin.js